import React, { useState, useEffect, useContext } from 'react';
import { withRouter, Switch, Route, Redirect } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import ConfirmAlert from 'modules/common/components/ConfirmAlert';
import GenericListPair from 'modules/common/components/GenericListPair';
import { ModalContext } from 'App';
import PropTypes from 'prop-types';
import useDebounce from 'modules/common/components/UseDebounce';

import * as actions from '../action';
import * as c from '../constant';

import FaqsMainContent from './FaqsMainContent';
import CreateModal from '../components/CreateModal';
import UpdateModal from '../components/UpdateModal';

const form = {
  keyword: '',
};

function FaqsMainContainer({
  match,
  history,
  getFaqList,
  faqList,
  faqListPager,
  isLoading,
  removeFaq,
}) {
  const [formData, setFormData] = useState(form);
  const setModal = useContext(ModalContext);

  const handleOnChange = e => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleAddModal = e => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: <CreateModal />,
      title: 'Add Frequently Asked Questions',
      modalSize: 'modal-xl',
    });
  };

  const handleEdit = data => e => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: <UpdateModal updateList={data.attributes} id={data.id} />,
      title: 'Update Frequently Asked Questions',
      modalSize: 'modal-xl',
    });
  };

  const handleRemove = data => e => {
    e.preventDefault();
    ConfirmAlert(
      'Are you sure, you want to remove this frequently asked question?',
      () => {
        removeFaq(data.id, () => {
          getFaqList();
          const id = _.get(faqList, '0.id');
          history.push(`/general-settings/faq/main/${id}`);
        });
      },
      () => {},
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      }
    );
  };

  useEffect(() => {
    getFaqList();
    return () => {
      setModal({ isOpen: false });
    };
  }, []);
  const debouncedSearchTerm = useDebounce(formData, 500);

  const param = {
    q: formData.keyword,
    sort_by: 'asc'
  };

  useEffect(() => {
    if (debouncedSearchTerm) {
      getFaqList({ name: formData.keyword });
    } else {
      setFormData([]);
    }
  }, [debouncedSearchTerm]);

  return (
    <div className="card-content-listing">
      <Route
        path={`${match.path}/:faqId?`}
        render={({ match: { params } }) => (
          <GenericListPair
            moduleName="Menu List"
            getData={getFaqList}
            setParams={param}
            setKeyword={handleOnChange}
            keyword={_.get(formData, 'keyword') || ''}
            keywordPlaceholder="Search menu..."
            pathName={`${match.path}/:faqId?`}
            listName="Title List"
            label="FAQ's List"
            renderItem={item => (
              <div className="px-3 py-3">
                {_.get(item, 'attributes.title_en')}
              </div>
            )}
            isLoading={isLoading}
            selected={params.faqId}
            data={faqList}
            dataPager={faqListPager}
            handleSelectRow={data => {
              history.push(`${match.url}/${_.get(data, 'id')}`);
            }}
            renderContent={() => (
              <React.Fragment>
                <Switch>
                  <Route
                    path={`${match.path}/:faqId?`}
                    render={() => (
                      <FaqsMainContent
                        handleAddModal={handleAddModal}
                        handleEdit={handleEdit}
                        handleRemove={handleRemove}
                      />
                    )}
                  />
                </Switch>
                <Route
                  path={`${match.path}/:faqId?`}
                  render={() =>
                    !params.faqId && faqList.length > 0 ? (
                      <Redirect
                        to={`${match.url}/${_.get(faqList, '0.id')}`}
                      />
                    ) : null
                  }
                />
              </React.Fragment>
            )}
          />
        )}
      />
    </div>
  );
}

FaqsMainContainer.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  getFaqList: PropTypes.instanceOf(Function).isRequired,
  faqList: PropTypes.instanceOf(Array).isRequired,
  faqListPager: PropTypes.instanceOf(Object).isRequired,
  removeFaq: PropTypes.instanceOf(Function).isRequired,
  isLoading: PropTypes.bool.isRequired,
};

const mapStateToProps = ({ api }) => ({
  faqList: _.get(api, `${c.GET_FAQ_LIST}.list`) || [],
  faqListPager: _.get(api, `${c.GET_FAQ_LIST}.pager`) || {},
  isLoading: _.get(api, 'loading', []).indexOf(c.GET_FAQ_LIST) > -1,
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(FaqsMainContainer);
